export const NoOp = () => {};

export function isAsyncFunction(fn?: Function) {
  return fn?.constructor?.name === 'AsyncFunction'
}

export const runAll = async (fns: AnyFunction[]) => {
  for (let fn of fns) {
    await fn();
  }
}
export const runAllFn = async (fns: AnyFunction[]) => await runAll(fns);